import { DATALAYER_EVENTS } from "./dataLayer";
import { OPTION_VALUES, PaymentOptionName } from "./InputValues";
import { PAGE_SECTIONS, PRODUCT_KEYS } from "./products";

export const HINDI = "hi";
export const ENGLISH = "en";
export const TAMIL = "ta";
export const TELUGU = "te";
export const MARATHI = "mr";
export const KANNADA = "kn";

export const AADHAR_WEB_SERVICE_DOWN = "Adhar webservice is down";
export const AEM_POC = "aempoc";

export const UNIFIED_SAVINGS_PAGE = "Unified Savings Page";

export const LANGUAGES = {
  options: {
    [ENGLISH]: {
      nativeName: "English",
      shortName: "En",
      name: "English",
      dataLayerEvent: DATALAYER_EVENTS.English_Selected,
    },
    [HINDI]: { nativeName: "हिंदी", shortName: "हिं", name: "Hindi", dataLayerEvent: DATALAYER_EVENTS.Hindi_Selected },
    [MARATHI]: {
      nativeName: "मराठी",
      name: "Marathi",
      dataLayerEvent: DATALAYER_EVENTS.Marathi_Selected,
    },
    [TELUGU]: {
      nativeName: "తెలుగు",
      name: "Telugu",
      dataLayerEvent: DATALAYER_EVENTS.Telugu_Selected,
    },
    [TAMIL]: {
      nativeName: "தமிழ்",
      name: "Tamil",
      dataLayerEvent: DATALAYER_EVENTS.Tamil_Selected,
    },
    [KANNADA]: {
      nativeName: "ಕನ್ನಡ",
      name: "Kannada",
      dataLayerEvent: DATALAYER_EVENTS.Kannada_Selected,
    },
  },
  short_codes: [ENGLISH, HINDI, MARATHI, TELUGU, KANNADA, TAMIL],
  default: ENGLISH,
  forLeads: {
    [ENGLISH]: "ENG",
    [HINDI]: "HIN",
  },
  forDropOff: {
    [ENGLISH]: "english",
    [HINDI]: "hindi",
  },
  dataLayerEvent: {},
  forPartner: {
    [HINDI]: "Hindi",
  },
};

export const SITE_DOMAIN = "icicilife.com";

export const ASSETS_PATH = process.env.REACT_APP_ASSET_PATH;
export const COMMON_ASSETS_PATH = "/content/dam/aem-ipru-common-preprod";
// change it to aem-apiuatmiddleware for uat

export const CURRENCY_SIGN = "₹";
export const DOLLAR_SIGN = "$";

export const COUNTRY = "India";

export const COUNTRY_CODE = 91;
export const BENEFIT_KNOWMORE_URL =
  "https://www.icicilife.com/term-insurance/icici-pru-health-management-and-wellbeing-services.html";

export const INSURANCE_SCHEMES = {
  SORRY_MESSAGE: {
    url: "https://www.icicilife.com/insurance-plans/buy-life-insurance-online.html?plans=savings&UID=43625",
    slug: "SORRY_MESSAGE",
    logo: "/content/dam/aem-sites-react-spa-ssr/calculator/savings_sorry.svg",
    eventTrack: {
      open: DATALAYER_EVENTS.ipstoother_plan_popup_open,
      close: DATALAYER_EVENTS.ipstoother_plan_popup_close,
      premium: DATALAYER_EVENTS.ipstoother_plan_check_premium,
    },
  },
  SARAL_BIMA: {
    url: "https://www.icicilife.com/life-insurance/icici-pru-saral-jeevan-bima.html?UID=43600",
    slug: "SARAL_BIMA",
    logo: "/content/dam/aem-sites-react-spa-ssr/calculator/logo_saral_jeevan.png",
    eventTrack: {
      open: DATALAYER_EVENTS.ipstosaraljeevan_popup_open,
      close: DATALAYER_EVENTS.ipstosaraljeevan_popup_close,
      premium: DATALAYER_EVENTS.ipstoother_plan_check_premium,
    },
  },
  ROP: {
    url: "https://www.icicilife.com/term-insurance-plans/return-of-premium-term-plan.html?UID=37074",
    slug: "ROP",
    logo: "/content/dam/aem-sites-react-spa-ssr/calculator/Ips-Rop2x.png",
  },
  PNG: {
    url: "https://www.icicilife.com/ulip-plans/buy-icici-protect-and-gain.html?UID=38524",
    slug: "PNG",
    logo: "/content/dam/aem-sites-react-spa-ssr/calculator/Logo_ProtectnGain_PC.png",
  },
  HUSBAND: {
    url: "",
    slug: "husband",
    logo: "",
  },
  NRI: {
    url: "",
    slug: "nri",
    logo: "",
  },
  DECLINED_COUNTRIES: {
    url: "https://www.icicilife.com/insurance-plans/buy-life-insurance-online.html?UID= 39671",
    slug: "DECLINED_COUNTRY",
    logo: "",
  },
  NRI_LESS_SALARY: {
    url: "https://www.icicilife.com/insurance-plans/buy-life-insurance-online.html?UID= 39671",
    slug: "NRI_LESS_SALARY",
    logo: "",
  },
  INDIVIDUAL_PLAN: {
    url: "https://www.icicilife.com/term-insurance-plans/iprotect-smart-term-insurance-calculator.html?UID=41105",
    slug: "INDIVIDUAL_PLAN",
    logo: "/content/dam/aem-sites-react-spa-ssr/ips-images/ips-logo.png",
  },
  JOINT_PLAN: {
    url: "https://www.icicilife.com/term-insurance-plans/iprotect-smart-term-insurance-calculator.html",
    slug: "JOINT_PLAN",
    logo: "/content/dam/aem-sites-react-spa-ssr/ips-images/ips-logo.png",
    url_2: "https://www.icicilife.com/life-insurance/icici-pru-saral-jeevan-bima.html",
    logo_2: "/content/dam/aem-sites-react-spa-ssr/calculator/logo_saral_jeevan.png",
  },
  CONTINUE_OR_IPS: {
    slug: "CONTINUE_OR_IPS",
  },
  IPS: {
    slug: "IPS",
  },
  SUPER: {
    url: "https://www.icicilife.com/term-insurance/buy-iprotect-super-online.html?UID=43663",
    slug: "SUPER",
    logo: "/content/dam/aem-sites-react-spa-ssr/calculator/logo_saral_jeevan.png",
    eventTrack: {
      open: DATALAYER_EVENTS.ipstosuper_popup_open,
      close: DATALAYER_EVENTS.ipstosuper_popup_close,
      premium: DATALAYER_EVENTS.ipstosuper_check_premium,
    },
  },
  SORRY_MESSAGE_BMI: {
    url: "https://www.icicilife.com/insurance-plans/buy-life-insurance-online.html?UID=45067",
    slug: "SORRY_MESSAGE_BMI",
    logo: "/content/dam/aem-sites-react-spa-ssr/calculator/savings_sorry.svg",
  },
  ONLY_IPS: {
    url: "https://www.icicilife.com/term-insurance-plans/iprotect-smart-term-insurance-calculator.html",
    slug: "IPS",
    logo: "/content/dam/aem-sites-react-spa-ssr/ips-images/ips-logo.png",
  },
  SIGNATURE_ASSURE: {
    url: "https://www.icicilife.com/ulip-plans/unit-linked-insurance-plans/buy-icici-pru-ulip-signature-assure.html?UID=43577",
    slug: "SIGNATURE_ASSURE",
    logo: "/content/dam/aem-sites-react-spa-ssr/signatureassure/ICICI-Pru-Signature-Assure-Logo.svg",
  },
};

export const SUCCESS = "SUCCESS";
export const FAILED = "FAILED";
export const ERROR = "ERROR";
export const NA = "NA";
export const OK = "OK";

export const FUND_PERFORMANCE_TYPES = {
  EQUITY: "Equity",
  BALANCED: "Balanced",
  DEBT: "Debt",
  ALL: "All",
};

export const STRATEGY_LABELS = {
  [FUND_PERFORMANCE_TYPES.EQUITY]: "fund.fundAllocation.aggressiveStrategy",
  [FUND_PERFORMANCE_TYPES.BALANCED]: "fund.fundAllocation.balancedStrategy",
  [FUND_PERFORMANCE_TYPES.DEBT]: "fund.fundAllocation.conservativeStrategy",
  [FUND_PERFORMANCE_TYPES.ALL]: "fund.fundAllocation.mixedStrategy",
};

export const CALCULATOR_FORM_DISCLAIMER =
  "By submitting my details, I override my NDNC registration and authorize ICICI Life and its representatives to contact me through call,RCS,WhatsApp or E-mail. I further consent to share my information on confidential basis with third parties for evaluating and processing this proposal.<br>If you wish to calculate your term insurance premium without sharing your personal details, <a className='terms-anchor'>Click Here</a>";

export const MOBILE_WIDTH = 920;
export const FOOTER_SCROLL_THRESHOLD = 1000;
export const MOBILE_FOOTER_SCROLL_THRESHOLD = 1600;
export const MIN_QUOTE_TRANSFER_AMOUNT = 2000;
export const TABLET_SCREEN_WIDTH = 1023;

export const UID_FOR_CHILD_PLANNING = "53251";

export const LANGUAGE_PARAM = "lan";

export const NRI_HELPDESK_START_TIME = 9;
export const NRI_HELPDESK_END_TIME = 21;

export const quoteConstant = {
  minTermForLp: 5,
  minPolicyAge: 18,
  maxAge: 60,
  wholeLifeAge: 99,
  maxPolicyTerm: 85,
  minPolicyTerm: 5,
  maxAgeForLimitedPay: 55,
  spMaxAgeForTerm: 75,
  singlePayMaxYears: 20,
  ciMaxTerms: 30,
  saMaxTerms: 67,
  ciSpYearly: 0.98,
  ciNonSpYearly: 0.96,
  ciNonSpYearlyOthersLt10: 0.92,
  ciNonSpYearlyOthersGt10: 0.875,
  wllpCharges: 0.85,
  monthlyCharges: 1.05,
  monthlyCharges1: 0.0833,
  halfYearlyCharges: 1.02,
  defaultIncomeDuration: 20, //years
  defaultIncreasingIncomeDuration: 10, //years
  minCoverTillAge: 20,
  maxCoverTillAge: 85,
  maxAgeForCI: 55,
  incomeDurationDiscount: {
    10: 15,
    20: 20,
    30: 30,
  },
  increasingIncomeMultiValue: 1.26,
  adbMaxLumpSum: 30000000,
  LIFE: "life",
  LIFE_ATPD: "life_atpd",
  ONLY_ATPD: "only_atpd",
  LIFE_PLUS: "lifePlus",
  LIFE_PLUS_ATPD: "lifePlus_atpd",
  LIFE_HEALTH: "lifeHealth",
  ALL_IN_ONE: "allInOne",
  ONLYWOP: "onlywop",
  NOATPD: "noatpd",
  LIFE_HOUSEWIFE: "life_housewife",
  LIFE_HEALTH_HOUSEWIFE: "lifeHealth_housewife",
  salariedDiscountPercent: 10,
  riderMultiple: 50000,
  minSumAssured: 5000000,
  minSumAssuredNegativePinCode: 15000000,
  maxCi: 15000000,
  minCi: 1000000,
  maxSumAssuredMultiple: 15,
  maxSumAssured: 999900000,
  smartExitAge: 65,
  smartExitMinLifeCover: 6000000,
  inflationRate: 5.02,
  HOUSEWIFE_MAX_LIFE_COVER: 10000000,
  HOUSEWIFE_DEFAULT_LIFE_COVER: 5000000,
  HOUSEWIFE_DEFAULT_CI_COVER: 1500000,
  minCICover: 500000,
  minADBCover: 100000,
  SalariedDiscountMinSA: 10000000,
  superMinLifeCover: 5000000,
  superMaxLifeCover: 20000000,
  superMinCi: 1000000,
  premiumRefundTerm: 31,
  premiumRefundCoverTillAge: 65,
  LP5_MAX_SA: 250000000,
  pngMinSumAssured: 5000000,
  pngMaxSumAssured: 400000000,
  pngMaxRiderAmount: 30000000,
  ciModalLoading: {
    [OPTION_VALUES.PAYMENT_TENURE.YEARLY]: 0,
    [OPTION_VALUES.PAYMENT_TENURE.HALF_YEARLY]: 0.02,
    [OPTION_VALUES.PAYMENT_TENURE.MONTHLY]: 0.05,
  },
  staffDiscountWLRP: 0.975,
  staffDiscountWLLP: 0.95,
  staffDiscountDefault: 0.99,
  compaionDiscountRp: 0.975,
  compaionDiscountSp: 0.99,
  compaionDiscountLp: 0.95,
};

export const PAYOUT_YEARS = [10, 20, 30];

export const IncomeMUltiplier = {
  10: 0.0083333,
  20: 0.0041667,
  30: 0.0027778,
};

export const PAYOUT_YEARS_MI = [
  {
    id: 10,
    name: "10 Years",
  },
  {
    id: 20,
    name: "20 Years",
  },
  {
    id: 30,
    name: "30 Years",
  },
];

export const shortCodes = {
  Male: "M",
  Female: "F",
  Smoker: "S",
  NonSmoker: "NS",
};

export const TAXES = {
  GST_RATE: 18,
};

export const LMS_CONSTANTS = {
  IPS_PAGE_URL: "https://www.icicilife.com/term-insurance-plans/iprotect-smart-term-insurance-calculator.html",
  IPS_PAGE_NAME: "Term Insurance Persona Calculator",
  IPS_PAGE_NAME_2: "Term Insurance Persona Calculator",
  [OPTION_VALUES.SP]: "Single_pay",
  [OPTION_VALUES.RP]: "Regular_Pay",
  [OPTION_VALUES.LP]: "Limited_Pay",
  [OPTION_VALUES.LUMP_SUM]: "LumpSum",
  [OPTION_VALUES.INCOME]: "RegularIncome",
  [OPTION_VALUES.INCREASING_INCOME]: "IncreasingIncome",
  [OPTION_VALUES.LUMP_SUM_AND_INCOME]: "LumpsumIncome",
  [OPTION_VALUES.PAYMENT_TENURE.MONTHLY]: "Monthly",
  [OPTION_VALUES.PAYMENT_TENURE.HALF_YEARLY]: "Half-Yearly",
  [OPTION_VALUES.PAYMENT_TENURE.YEARLY]: "Yearly",
  [HINDI]: "hin",
  [ENGLISH]: "eng",
  [PaymentOptionName.L_P]: "limited_pay",
  [PaymentOptionName.S_P]: "single_pay",
  [PaymentOptionName.R_P]: "regular_pay",
  IPS_SUPER_PAGE_NAME: "Term Insurance Super Calculator",
  IPS_SUPER_PAGE_URL: "https://www.icicilife.com/term-insurance/buy-iprotect-super-online.html",
  I_WISH_PAGE_NAME: "Women Health Plan WISH Calculator",
  I_WISH_PAGE_URL: "https://www.icicilife.com/health-insurance/buy-icici-pru-wish.html",
};

export const API_CONSTANTS = {
  appName: "BOLDigiDrive",
  reqType: "COMM",
  reqSubType: "DROPOFFADD",
  source: "NEWBOL",
  sourceKey: "NEWBOLKEY",
  isSolution: "N",
  sourceNew: "GCNEWBOL",
  sourceKeyNew: "GCNEWBOLKEY",
};

export const APP_FORM_CONSTANTS = {
  LABELLED: "labelled",
  READ_ONLY_FIELDS: ["tobacco", "diabetes"],
  HEALTH_QUESTIONS: {
    ALCOHOL: "alcohol",
    TOBACCO: "tobacco",
    HAZARDOUS: "hazardousOccupation",
    PREGNANT: "pregnant",
    HEALTH_DISEASES: ["weightLoss"],
    DIABETES: "diabetes",
  },
  FOLLOW_UP: ["tobacco", "alcohol"],
  MIN_SALARY: 200000,
  MAX_SALARY: 500000000,
  NRI: "NRI",
  MIN_LENGTH: 1,
  MAX_LENGTH: 30,
};

export const CURRENT = "current";
export const UPCOMING = "upcoming";
export const COMPLETE = "complete";
export const mailDomains = ["gmail.com", "yahoo.com", "yahoo.co.in", "hotmail.com"];
export const DUMMY_OB_NO = "OB11223344";

export const IMAGE_TYPE = { "image/png": "png", "image/svg+xml": "svg", "image/jpeg": "jpg", "application/pdf": "pdf" };
export const QUOTE_API_CONSTANTS = {
  ONLINE_SALES_CHANNEL: 7,
  OFFLINE_SALES_CHANNEL: 0,
  ONLINE_SALES_MODE: "ON",
  OFFLINE_SALES_MODE: "OF",
};

export const FUND_NAMES = {
  INCOME_FUND: { name: "fund.fundAllocation.incomeFund", value: "Income Fund" },
  MONEY_MARKET_FUND: { name: "fund.fundAllocation.moneyMarketFund", value: "Money Market Fund" },
  MULTI_CAP_GROWTH_FUND: { name: "fund.fundAllocation.multiCapGrowthFund", value: "Multi Cap Growth Fund" },
  PENSION_MULTI_CAP_GROWTH_FUND: {
    name: "fund.fundAllocation.pensionMultiCapGrowthFund",
    value: "Pension Multi Cap Growth Fund",
  },
  PENSION_INCOME_FUND: { name: "fund.fundAllocation.pensionIncomeFund", value: "Pension Income Fund" },
};
export const FUND_FIXED_VALUE = {
  INCOME_FUND: 25,
  MULTI_CAP_GROWTH_FUND: 75,
};

export const FUND_TYPE_COLORS = {
  Equity: "bg-off-white-300",
  Balanced: "bg-light-green-500",
  Debt: "bg-light-yellow",
};

export const IWishPlans = {
  HEALTH: "health",
  HEALTH_PLUS: "healthplus",
  HEALTH_PLUS_MAX_AGE: 37,
};

export const VIEW_ALL = "view-all";

export const LifeCoverOption = {
  [quoteConstant.LIFE]: "Life",
  [quoteConstant.LIFE_PLUS]: "Life Plus",
  [quoteConstant.LIFE_HEALTH]: "Life and Health",
  [quoteConstant.ALL_IN_ONE]: "All in One",
  [IWishPlans.HEALTH]: "Health",
  [IWishPlans.HEALTH_PLUS]: "HealthPlus",
};

export const SavingsAppFormSteps = {
  ADHAR_DETAILS: 1,
  PERSONAL_DETAIL: 2,
  HEALTH_DETAIL: 3,
  PAYOUT_DETAIL: 4,
  PREVIEW_DETAIL: 5,
  DOCUMENT_DETAIL: 6,
};

export const stepIds = {
  AADHAR_DETAILS: "aadhar",
  PERSONAL_DETAIL: "personalDetails",
  HEALTH_DETAIL: "healthDetails",
  PAYOUT_DETAIL: "payoutDetails",
  PREVIEW_DETAIL: "previewDetails",
  DOCUMENT_DETAIL: "documentDetails",
  LIFE_ASSURED_HEALTH_DETAILS: "lifeAssuredHealthDetails",
};

export const SavingsAppFormStepTitles = {
  1: "kyc",
  2: "personal",
  3: "health",
  4: "payout",
  5: "preview",
  6: "document",
};

export const AGE = {
  MAX_AGE: 105,
  MIN_AGE: 0,
  ADULT_AGE: 18,
};
export const MONTHS_ABBR = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MONTHS_SHORT_NAME = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const HINDI_MONTHS_NAME = [
  "जनवरी",
  "फरवरी",
  "मार्च",
  "अप्रैल",
  "मई",
  "जून",
  "जुलाई",
  "अगस्त",
  "सितंबर",
  "अक्टूबर",
  "नवंबर",
  "दिसंबर",
];

export const APPOINTMENT_SCHEDULING_IDS = [
  7484, 37024, 35533, 38282, 34637, 36720, 34631, 36959, 5967, 37577, 7462, 34692, 37466, 5968, 37023, 37461, 36718,
  36012, 36960, 31937, 35436, 38053, 37509, 37578, 36009, 37511, 5970, 38485, 38486, 38482, 38937, 38969, 38977, 38978,
  38970, 39223, 39224,
];

export const PERSONA_LIST = {
  PARTNER: "partnerpersonaaaa",
  JOINTLIFE: "jointlifeeeee",
  EMPLOYEE: "employee",
  MONTHLYINCOME: "monthlyincomeeee",
  SMARTEXIT: "smartexitttt",
  WORKINGWOMEN: "Working_Womennnn",
  LIMITEDPAY: "Limited_Payyyyy",
  ALLINONE: "All_in_Oneeee",
  INFROMAL: "informal",
  OTC: "otc",  
  NRI: "nri",
  WEGA: "wega",
  STUDENT: "student",
  TENYEARS: "tenyears",
  VARIANT_B: "variantB",
  VARIANT_A: "variantA",
};

export const EMPLOYEE_DISCOUNT_FORM = {
  PARTNER: "employee",
};

export const TENURE = {
  HALF_YEARLY: 2,
  MONTHLY: 12,
  YEARLY: 1,
};

export const BASE_PATH = "/etc.clientlibs/aem-sites-react-spa-ssr/clientlibs/clientlib-react/resources";

export const APP_KEY_BLOWFISH = "!i@*6@($%(";
export const APP_KEY_BLOWFISH2 = "!t@a6@($%(";
export const APP_KEY_BLOWFISH3 = "DIGI1234";
export const TAB_CONSTANT = {
  PERSONAL_DETAIL: 0,
  OCCUPATION: 1,
  NOMINEE: 2,
  OCCUPATION_ACTIVITY_HAZARD: 0,
  HABITS: 1,
  PROPOSER_HEALTH: 2,
  HEALTH_DETAIL: 0,
  PAYOUT_DETAILS: 0,
};

export const SAVINGS_HEALTH_DETAIL_TAB = {
  OCCUPATION_ACTIVITY_HAZARD: 0,
  HABITS: 1,
  PROPOSER_HEALTH: 2,
};

export const QDATA_TYPE = {
  DEVICE_FLAG: "deviceFlag",
  SUITABILITY: "suitablity",
};

export const APP_CRYPTO_KEY = "ICICPRUA768UATD0GH6ASDFGUATFU7Y8";
export const APP_CRYPTO_IV = "aPdSgVkYp3s6v9y$";
export const ThankYouPage = "https://www.icicilife.com/thank-you-r.html";
export const ThankYouPagePreprod = "https://www.icicilife.com/preprod/thank-you-r.html";

export const FundTabs = {
  AS_PER_YOUR_CHOICE: "As per your choice",
  AS_PER_YOUR_AGE: "As per your age",
  TARGET_ASSET_STRATEGY: "Target asset strategy",
  TRIGGER_PORTFOLIO_STRATEGY: "Trigger portfolio strategy 2",
};

export const TRULY = ["yes", "y"];
export const FALSY = ["no", "n", ""];

export const FundAllocation = {
  MAX_AGE: 75,
  WHOLE_LIFE_AGE: 99,
  MIN_PAYOUT_YEAR: 6,
};

export const CALCULATOR_INPUT_TYPE = {
  RADIO: "radio",
  DROPDOWN: "dropdown",
  RADIO_DROPDOWN: "radio_dropdown",
};

export const THEME_COLORS = {
  RED: "red",
  BLUE: "blue",
};

export const INCOME_RANGE_CONSTANTS = {
  LESS_THAN_FIVE: "<5L",
  LESS_THAN_SEVEN: "5-7.5L",
  LESS_THAN_TEN: "7.5-10L",
  LESS_THAN_FIFTEEN: "10-15L",
  LESS_THAN_TWENTY: "15-20L",
  GREATER_THAN_TWENTY: ">20L",
};

export const AGE_RANGE_CONSTANTS = {
  LESS_THAN_THIRTY: "<30",
  LESS_THAN_FOURTY: "31-40",
  LESS_THAN_FIFTY: "41-50",
  GREATER_THAN_FIFTY: ">50",
};

export const MONTHLY = "Monthly";
export const HALF_YEARLY = "Half-Yearly";
export const YEARLY = "Yearly";

export const QUOTE_PREMIUM_CONSTANTS = {
  MONTHLY_MIN_INCOME_1: 500000,
  MONTHLY_MIN_INCOME_2: 750000,
  MONTHLY_MIN_INCOME: 1000000,
  YEARLY_MIN_INCOME: 1500000,
  YEARLY_MAX_INCOME: 2000000,
};
export const GIFT_PRO_ONLINE_DISCOUNT_PCT = 3;

export const GIFT_PRODUCT = "gift-pro";
export const SIGNATUREULIP_PRODUCT = "signature-ulip";

export const RIDERS_REQUEST_BODY_FIELDS = {
  ADBY: "ADBV",
  ACPD: "ATPD",
  WOP: "WOP",
  BTBB: "BTBB",
};

export const RESPONSE_RIDERS_FIELDS = {
  ADBV: "ADBY",
  ATPD: "ACPD",
  WOP: "WOP",
  BTBB: "BTBB",
};
export const existingCustomerDataLayerConfig = {
  AppForm_EC_PhoneNumber_confirm: {
    event: DATALAYER_EVENTS.AppForm_EC_PhoneNumber_confirm,
    currentSection: PAGE_SECTIONS.appform,
  },
  AppForm_EC_OTP_PopUpOpen: {
    event: DATALAYER_EVENTS.AppForm_EC_OTP_PopUpOpen,
    currentSection: PAGE_SECTIONS.appform,
  },
  AppForm_EC_OTP_Verified: {
    event: DATALAYER_EVENTS.AppForm_EC_OTP_Verified,
    currentSection: PAGE_SECTIONS.appform,
  },
  AppForm_EC_OTP_NotVerified: {
    event: DATALAYER_EVENTS.AppForm_EC_OTP_NotVerified,
    currentSection: PAGE_SECTIONS.appform,
  },
  AppForm_EC_OTP_Resend: {
    event: DATALAYER_EVENTS.AppForm_EC_OTP_Resend,
    currentSection: PAGE_SECTIONS.appform,
  },
  AppForm_EC_OTP_Cancel: {
    event: DATALAYER_EVENTS.AppForm_EC_OTP_Cancel,
    currentSection: PAGE_SECTIONS.appform,
  },
  AppForm_EC_PopUpclose: {
    event: DATALAYER_EVENTS.AppForm_EC_PopUpclose,
    currentSection: PAGE_SECTIONS.appform,
  },
  AppForm_EC_OTP_PopUpClose: {
    event: DATALAYER_EVENTS.AppForm_EC_OTP_PopUpClose,
    currentSection: PAGE_SECTIONS.appform,
  },
};

export const ACCOUNT_DETAILS_CONSTANT = {
  CHEQUE: 0,
  PASSBOOK: 1,
  NET_BANKING: 2,
};

export const APP_FORM_EVENT_TRACK = {
  personalDetails: {
    event: DATALAYER_EVENTS.AppForm_PersonalDetails_Question,
    currentSection: PAGE_SECTIONS.appFormPersonalDetails,
  },
  healthDetails: {
    event: DATALAYER_EVENTS.AppForm_HealthDetails_Question,
    currentSection: PAGE_SECTIONS.appFormHealthDetails,
  },
  payoutDetails: {
    event: DATALAYER_EVENTS.AppForm_PayoutDetails_Selected,
    currentSection: PAGE_SECTIONS.appFormPayoutAccDetail,
  },
};
export const SUPER_ADBV = "ADBV";
export const SUPER_ATPD = "ATPD";
export const allowedFileTypes = ["image/jpg", "image/jpeg", "image/png", "application/pdf"];

export const SPOUSE_COVER = "SPOUSE_COVER";

export const APPLICATION_ONE = "appFormData";
export const APPLICATION_TWO = SPOUSE_COVER;

export const SavingQuoteContextForm = {
  defeaultIncomeStartsFrom: 9,
};

export const premiumRefundOptions = [
  { id: 0, name: "0%" },
  { id: 100, name: "100%" },
  { id: 200, name: "200%" },
];
export const premiumRefundOptions60 = [
  { id: 0, name: "0%" },
  { id: 100, name: "100%" },
];

export const MAXIMUM_MATURITY_AGE = 75;

export const MAX_SUPER_ADB = 3000000;
export const MAX_SUPER_CI = 3000000;

export const NETCORE_REGISTRATION_KEY = "ADGMOT35CHFLVDHBJNIG50K96AB3265CFJ9HQV6BHLDR1618Q7Q0";
export const NETCORE_CREATION_KEY = "2840969d076fe99d2d26578c153de8e9";

export const CTEVENTNAME = {
  ips: {
    ProductPage: "IPS Plus_ProductPage",
    CheckPremium: "IPS Plus_CheckReturn",
    QuoteProceed: "IPS Plus_QuoteProceed ",
    ProceedtoPayment: "IPS Plus_Proceedtopayment ",
  },
  "ips-super": {
    ProductPage: "Super_ProductPage",
    CheckPremium: "Super_CheckPremium",
    QuoteProceed: "Super_QuoteProceed",
    ProceedtoPayment: "Super_ProceedtoPayment",
  },
  "signature-ulip": {
    ProductPage: "Signature_ProductPage",
    CheckPremium: "Signature_CheckReturn",
    QuoteProceed: "Signature _QuoteProceed",
    ProceedtoPayment: "Signature_ProceedtoPayment",
  },
  [PRODUCT_KEYS.SIP_PLUS]: {
    ProductPage: "SIP_ProductPage ",
    CheckPremium: "SIP_CheckReturn",
    QuoteProceed: "SIP_QuoteProceed ",
    ProceedtoPayment: "SIP_Proceedtopayment ",
  },
  [PRODUCT_KEYS.SIGNATURE_ASSURE]: {
    ProductPage: "SigAssure_ProductPage ",
    CheckPremium: "SigAssure_CheckReturn",
    QuoteProceed: "SigAssure_QuoteProceed ",
    ProceedtoPayment: "SigAssure_Proceedtopayment ",
  },
};

export const productCTName = {
  ips: "IPS",
  "ips-super": "Super",
  [PRODUCT_KEYS.SIP_PLUS]: "SIP Plus",
  [PRODUCT_KEYS.SIGNATURE_ASSURE]: "Signature Assure",
};
export const MIN_PASTPERFORMANCE = 8;

export const SIGNATURE_SWP = {
  DOITYOURSELF: "Do It Yourself",
  RETIREMENT: "Retirement",
};

// export const MORNING_STAR_FUND_CODES = ["COPF", "OPPF", "MCBF", "BADF"];

// export const MORNING_STAR_FUND_PRODUCTS = [PRODUCT_KEYS.SIGNATUREULIP, PRODUCT_KEYS.PNG];

export const PARTNER_LIST = {
  DEV1: "dev1",
  DEV: "dev",
  STAGING: "staging",
  PROD: "prod",
};

export const PENNY_DROP_ELIGIBLE_PRODUCTS = [PRODUCT_KEYS.SIGNATURE_YOUTH];

export const LanguageHidePage = ["persona", "buy-icici-pru-wish"];
export const LargerProductIconsPages = ["buy-icici-pru-wish"];
export const LIGO_PRODUCTS = [PRODUCT_KEYS.IPS, PRODUCT_KEYS.SIGNATURE_ASSURE, PRODUCT_KEYS.IPS_SUPER];
export const IIB_POLICY_STATUS_MAP = {
  1: {
    uiName: "Pending",
    jsonName: "Proposal received/Pending for U/w",
  },
  2: {
    uiName: "Freelook Cancellation",
    jsonName: "Cooling off cancellation/Freelook Cancellation",
  },
  3: {
    uiName: "Cheque Dishonoured",
    jsonName: "First Premium (NB) Cheque Dishonour",
  },
  4: {
    uiName: "Null & Void",
    jsonName: "Null & Void",
  },
  5: {
    uiName: "Cancelled",
    jsonName: "Cancelled from Inception",
  },
  6: {
    uiName: "Cancelled (other reasons)",
    jsonName: "Cancelled due to other reasons",
  },
  7: {
    uiName: "Declined",
    jsonName: "Proposal declined",
  },
  8: {
    uiName: "Withdrawn",
    jsonName: "Withdrawn/Not taken up",
  },
  9: {
    uiName: "Postponed",
    jsonName: "Risk Postponed",
  },
  10: {
    uiName: "Issued",
    jsonName: "Inforce",
  },
  11: {
    uiName: "Reduced Paid Up",
    jsonName: "Reduced Paid Up",
  },
  12: {
    uiName: "Lapsed",
    jsonName: "Lapsed",
  },
  13: {
    uiName: "Surrendered",
    jsonName: "Surrendered",
  },
  14: {
    uiName: "Maturity Claim",
    jsonName: "Maturity Claim",
  },
  15: {
    uiName: "Death claim",
    jsonName: "Death Claim Intimated & being processed",
  },
  16: {
    uiName: "Death Claim Settled",
    jsonName: "Death Claim Settled",
  },
  17: {
    uiName: "Death Claim Rejected",
    jsonName: "Death Claim Repudiated",
  },
  18: {
    uiName: "First death reported (Joint Life)",
    jsonName: "Joint Life - First Death Reported/Settled",
  },
  19: {
    uiName: "Waiver of premium applicable",
    jsonName: "Premium Waiver Benefit applicable/Premiums funded by Insurer",
  },
  20: {
    uiName: "Discontinued (ULIP)",
    jsonName: "Discontinued (ULIP)",
  },
  21: {
    uiName: "Foreclosed",
    jsonName: "Foreclosed",
  },
  22: {
    uiName: "Extended Life Cover",
    jsonName: "Extended Life Cover",
  },
  23: {
    uiName: "Termination",
    jsonName: "Premature Termination",
  },
};
export const IIB_PRIORITY_MAP = {
  17: 1,
  16: 2,
  15: 3,
  4: 4,
  18: 5,
  19: 6,
  9: 7,
  7: 8,
  5: 9,
  6: 10,
  8: 11,
};

export const IIB_QUEST_COMPANY_NUMBER = {
  101: "HDFC Standard Life Insurance",
  104: "Max Life Insurance Co. Ltd.",
  105: "ICICI Life Insurance Co. Ltd,", // chnages ,
  107: "Kotak Mahindra Life Insurance Co. Ltd.",
  109: "Aditya Birla SunLife Insurance Co. Ltd.",
  110: "Tata AIA Life Insurance",
  111: "SBI Life Insurance",
  114: "Exide Life Insurance Co. Ltd.",
  116: "Bajaj Allianz Life Insurance",
  117: "PNB MetLife India Insurance Co. Ltd.",
  121: "Reliance Nippon Life Insurance Company",
  122: "Aviva Life Insurance",
  127: "SAHARA INDIA Life Insurance",
  128: "Shriram Life Insurance",
  130: "Bharti AXA Life Insurance",
  133: "Future Generali India Life Insurance Company Limited",
  136: "Canara HSBC Oriental Bank of Commerce Life Insurance Company Limited",
  138: "Aegon Life Insurance Company Limited",
  140: "DLF Pramerica Life Insurance Co. Ltde", // wrong spelling
  142: "Star Union Dai-ichi Life Insurance Co Ltd",
  143: "India First Life Insurance",
  147: "Edelwiess Tokio Life Insurance Co. Ltd", // wrong spelling
  512: "Life Insurance Corporation of India",
};

export const IIB_PRODUCT_TYPE = {
  EN: {
    uiName: "Money Back/Whole Life",
    jsonName: "Endowment (including Money Back & Whole Life type)",
  },
  TA: {
    uiName: "Pure Term",
    jsonName: "Pure Term Assurance",
  },
  TO: {
    uiName: "Term with MoneyBack",
    jsonName: "Term Assurance - Others (TROP, etc.)",
  },
  PH: {
    uiName: "Pure Health",
    jsonName: "Pure Health Cover",
  },
  SH: {
    uiName: "Savings linked Health Cover",
    jsonName: "Savings linked Health Cover",
  },
  AN: {
    uiName: "Annuity",
    jsonName: "Annuity",
  },
  PS: {
    uiName: "Pension",
    jsonName: "Pension",
  },
  CL: {
    uiName: "Credit Life",
    jsonName: "Credit Life",
  },
  OT: {
    uiName: "Other Product",
    jsonName: "Any Other Product",
  },
};

export const showReasonForFieldsValue = ["Proposal declined", "Withdrawn/Not taken up", "Risk Postponed"];

export const ELIGIBLE_APPOINTMENT_SCHEDULING_PRODUCTS = [
  PRODUCT_KEYS.SIGNATURE_ASSURE,
  PRODUCT_KEYS.SIP_PLUS,
  PRODUCT_KEYS.PNG,
  PRODUCT_KEYS.GPP_FLEXI,
  PRODUCT_KEYS.GIFTPRO,
  PRODUCT_KEYS.SIGNATURE_PENSION,
  PRODUCT_KEYS.SMARTKID_360,
  PRODUCT_KEYS.SMARTKID_ASSURE,
];

export const OTC = {
  MOBILE: "Mobile",
  EMAIL: "Email",
  ORGANIZATION_DETAILS: "Organization_Details",
  INCOME_DETAILS: "Income_Details",
  HEALTH_DETAILS: "Your_Body_Mass_Index",
  NOMINEE_DETAILS: "Nominee_Details",
  APPOINTEE_DETAILS: "Appointee_Details",
  PERSONAL_DETAILS: "Personal_Details",
};
export const FUNDS_REQUIRED_PRODUCTS = [
  PRODUCT_KEYS.SIGNATURE_ASSURE,
  PRODUCT_KEYS.PNG,
  PRODUCT_KEYS.SMARTKID_ASSURE,
  PRODUCT_KEYS.SIGNATUREULIP,
  PRODUCT_KEYS.SIP_PLUS,
  PRODUCT_KEYS.SIGNATURE_PENSION,
  PRODUCT_KEYS.SIGNATURE_SECURE,
];

export const PARTNER_DIRECT_REDIRECTION_ELIGIBLE_PRODUCTS = [PRODUCT_KEYS.CAPITAL_GUARANTEE_II];

export const GPP_ANNUITY_OPTION_IA = "LIFE ANNUITY WITHOUT RETURN OF PURCHASE PRICE";

export const GPP_ANNUITY_OPTION_DA = [
  "DEFERRED SINGLE LIFE WITH RETURN OF PURCHASE PRICE",
  "DEFERRED SINGLE LIFE WITH RETURN OF PURCHASE PRICE ON CI OR PD OR DEATH",
  "DEFERRED JOINT LIFE WITH RETURN OF PURCHASE PRICE",
];
export const FUND_RATES = {
  "Money Market Fund": 0.75,
};
export const IS_NO = "N";
export const IS_YES = "Y";
export const INCOME_LA_ID = "incomeLA";
export const INCOME = "income";

export const MONEY_MARKET_FUND = "MMAF";

export const PENSION_MONEY_MARKET_FUND = "PMMF";

export const BEVI_DATE_RANGE = {
  startDate: "2026-05-01",
  endDate: "2026-05-18",
};
export const LMCF_DATE_RANGE = {
  startDate: "2026-06-02",
  endDate: "2026-07-01",
};

export const FUND_DATE_RANGES = {
  BEVI: BEVI_DATE_RANGE,
  LMCF: LMCF_DATE_RANGE,
};

export const GPP_JOIN_LIFE_ANNUITY_OPTIONS = [
  "DEFERRED JOINT LIFE WITH RETURN OF PURCHASE PRICE",
  "JOINT LIFE, LAST SURVIVOR WITHOUT RETURN OF PURCHASE PRICE",
  "JOINT LIFE, LAST SURVIVOR WITH RETURN OF PURCHASE PRICE",
  "FamilyInc ROP Joint Life",
];

export const Q_Data_PROCEED_STEP = "step";

export const QDATA_VALUES_STEP_ID = {
  LANDING_PAGE: "1",
};

export const MINIMUM_INVEST_NFO_VALUE = 2500;

export const GROUP_EMP_PRODUCTS = [PRODUCT_KEYS.IPROP];

export const STAGE_COMPLETED = {
  KYC: "KYC",
  REVIEW: "Review",
  HABITS: "Habits LA",
  OCCUPATION: "Occ Avo LA",
  HEALTH: "Health LA",
  PERSONAL: "Personal",
  PAYOUT: "Payout",
  PAYMENT: "Payment",
  PROCEED_TO_PAYMENT: "Proceed to Payment",
  PAYMENT_INITIATED: "Payment Initiated",
  THANK_YOU: "Thank You",
  ERROR: "Error",
};
export const MVPF_FUND_CODE = "MVPF";
export const BIMF_FUND_CODE = "BIMF";
